import { css } from '@mui/material'

import { unit } from '../utils'

export const serratedEdgeHorizontalCss = css`
  // https://css-generators.com/custom-borders/
  mask: conic-gradient(from -45deg at bottom, #0000, #000 1deg 89deg, #0000 90deg) 50% / ${unit(3)} 100%;
`
